import React, { useState } from 'react';

import { catEmojis } from '../../constants';
import ModeToggle from './ModeToggle';

const setRandomEmoji = () => catEmojis[Math.floor(Math.random() * catEmojis.length)];

const Header = ({ onModeToggle }) => {
  const [currentEmoji, setCurrentEmoji] = useState('😻');

  return (
    <div className="w-full p-2 sm:p-5 flex">
      <div className="flex justify-start sm:w-1/2">
        <div className="pt-2 text-3xl cursor-pointer">
          <button 
            className="focus:outline-none"
            onClick={() => setCurrentEmoji(setRandomEmoji())}
          >
            {currentEmoji}
          </button>
        </div>
      </div>
      <div className="flex justify-end flex-1 sm:w-1/2 gap-2 sm:gap-10">
        <div className="py-3 self-center justify-end">
          <ModeToggle onModeToggle={onModeToggle} />
        </div>
        <div className="flex align-center justify-end">
          <div className="inline-block self-center">
            <a 
              className="px-3 py-2 bg-green-500 hover:bg-green-400 rounded-full text-white text-center focus:outline-none appearance-none text-sm"
              title="Buy me a coffee" 
              href="https://ko-fi.com/Y8Y02U3IA" 
              target="_blank"
              rel="noreferrer"
            >
              <img 
                src="https://storage.ko-fi.com/cdn/cup-border.png" 
                alt="Ko-fi donations" 
                className="inline-block w-6 mr-2"
              />
              Buy me a coffee
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
